import api from '../../api'
import {
  SET_TOKEN,
  SET_UID,
  SET_USERINFO,
  AUTOLOGIN,
  LOGOUT,
  SECONDVERIFY
} from '../mutation-types'
import Cookies from 'js-cookie'
const cookieDomain = '.yqda.net'
const cookieUid = Cookies.get('uid')
const cookieToken = Cookies.get('token')
const cookieUserinfo = Cookies.get('userinfo')
const cookieSecondverify = Cookies.get('secondverify')

// initial state
const state = {
  uid: cookieUid === undefined ? null : cookieUid,
  token: cookieToken === undefined ? null : decodeURIComponent(cookieToken),
  userinfo: cookieUserinfo === undefined ? null : JSON.parse(decodeURIComponent(cookieUserinfo)),
  secondverify: cookieSecondverify === undefined ? 0 : cookieSecondverify
}

// getters
const getters = {
  token: (state, getters) => {
    return state.token
  },
  loginState: (state, getters) => {
    if (state.token === null) {
      return false
    } else {
      return true
    }
  },
  secondVerifyState: (state, getters) => {
    return parseInt(state.secondverify) + 5 * 60 * 1000 > new Date().getTime()
  },
  userinfo: (state, getters) => {
    const userinfo = {
      mobile: '',
      realname: '',
      email: '',
      emailverify: 0,
      avatar: ''
    }
    return state.userinfo !== null ? state.userinfo : userinfo
  }
}

// actions
const actions = {
  Login ({ commit }, user) {
    commit(LOGOUT)
    return api.user.login(user)
      .then(res => {
        const userinfo = res.data.data.userinfo
        if (userinfo && res.data.code === 200) { // 如果登录成功
          commit(SET_TOKEN, res.data.data.token)
          commit(SET_UID, userinfo.uid)
          commit(SET_USERINFO, userinfo)
          commit(AUTOLOGIN, user.remember)
        }
        return res
      })
  },
  Logout ({ commit }) {
    return api.user.logout()
      .then(res => {
        commit(LOGOUT)
        return res
      })
  },
  secondVerify ({ commit }, params) {
    return api.user.secondVerify(params)
      .then(res => {
        if (res.data.code === 200) {
          commit(SECONDVERIFY)
        }
        return res
      })
  },
  UpdateUserinfo ({ commit }) {
    return api.user.getUserInfo()
      .then(res => {
        if (res.data.code === 200) {
          commit(SET_USERINFO, res.data.data)
        }
        return res
      })
  }
}

// mutations
const mutations = {
  [SET_TOKEN] (state, token) {
    state.token = token
    Cookies.set('token', token, { domain: cookieDomain })
  },
  [SET_UID] (state, uid) {
    state.uid = uid
    Cookies.set('uid', uid, { domain: cookieDomain })
  },
  [SET_USERINFO] (state, userinfo) {
    state.userinfo = userinfo
    Cookies.set('userinfo', state.userinfo, { domain: cookieDomain })
  },
  [SECONDVERIFY] (state) {
    const timestamp = new Date().getTime()
    state.secondverify = timestamp
    Cookies.set('secondverify', timestamp, { domain: cookieDomain })
  },
  [AUTOLOGIN] (state, value) {
    if (value) {
      Cookies.set('token', state.token, { expires: 10, domain: cookieDomain })
      Cookies.set('uid', state.uid, { expires: 10, domain: cookieDomain })
      Cookies.set('userinfo', state.userinfo, { expires: 10, domain: cookieDomain })
    }
  },
  [LOGOUT] (state) {
    state.uid = null
    state.token = null
    state.userinfo = null
    state.secondverify = null
    Cookies.remove('token', { domain: cookieDomain })
    Cookies.remove('uid', { domain: cookieDomain })
    Cookies.remove('userinfo', { domain: cookieDomain })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
